/**
 * @generated SignedSource<<61cd1a0be9258f684a0fdc5fd4a8c53d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type PlacementOutputFileType = "ONE_FILE_FOR_ALL_DESIGN" | "ONE_FILE_FOR_EACH_DESIGN";
export type PlacementOutputInputUpdateInput = {
  dpi: number;
  heightCM: number;
  id?: string | null;
  isEnabled: number;
  jsonArea?: string | null;
  modelID: number;
  name: string;
  placementOutputAreaItems: ReadonlyArray<PlacementOutputAreaItemInput>;
  placementOutputItems: ReadonlyArray<PlacementOutputItemInput>;
  placementOutputLayers: ReadonlyArray<PlacementOutputLayerInput>;
  settings?: PlacementSettingsInput | null;
  templateFileID?: any | null;
  templateFileObjectID?: number | null;
  widthCM: number;
};
export type PlacementSettingsInput = {
  backgroundAsFillBackgroundTool: boolean;
  placementOutputFileType: PlacementOutputFileType;
};
export type PlacementOutputAreaItemInput = {
  areaID: number;
  colorID: number;
  json: string;
  placementOutputAreaItemID: number;
  sideID: number;
  svg: string;
};
export type PlacementOutputItemInput = {
  colorID?: number | null;
  json: string;
  placementOutputItemID: number;
};
export type PlacementOutputLayerInput = {
  colorID: number;
  fileID?: any | null;
  fileObjectID: number;
  jsonArea?: string | null;
  placementOutputLayerID: number;
};
export type placementUpdatePlacementOutputMutation$variables = {
  input?: PlacementOutputInputUpdateInput | null;
  inputCompressed?: string | null;
};
export type placementUpdatePlacementOutputMutation$data = {
  readonly updatePlacementOutput: {
    readonly placementOutput: {
      readonly dpi: number;
      readonly heightCM: number;
      readonly id: string;
      readonly isEnabled: boolean;
      readonly jsonArea: string | null;
      readonly modelID: number;
      readonly name: string;
      readonly placementOutputAreaItems: ReadonlyArray<{
        readonly areaID: number;
        readonly colorID: number;
        readonly json: string;
        readonly placementOutputAreaItemID: number;
        readonly sideID: number;
        readonly svg: string;
      }>;
      readonly placementOutputItems: ReadonlyArray<{
        readonly colorID: number | null;
        readonly json: string;
        readonly placementOutputItemID: number;
      }>;
      readonly placementOutputLayers: ReadonlyArray<{
        readonly colorID: number;
        readonly fileID: any | null;
        readonly fileObjectID: number;
        readonly jsonArea: string | null;
        readonly placementOutputLayerID: number;
      }>;
      readonly settings: {
        readonly backgroundAsFillBackgroundTool: boolean;
        readonly placementOutputFileType: PlacementOutputFileType;
      } | null;
      readonly templateFileID: any | null;
      readonly templateFileObjectID: number | null;
      readonly widthCM: number;
    } | null;
  };
};
export type placementUpdatePlacementOutputMutation = {
  response: placementUpdatePlacementOutputMutation$data;
  variables: placementUpdatePlacementOutputMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "inputCompressed"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "jsonArea",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "colorID",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "json",
  "storageKey": null
},
v4 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      },
      {
        "kind": "Variable",
        "name": "inputCompressed",
        "variableName": "inputCompressed"
      }
    ],
    "concreteType": "PlacementOutput_Output",
    "kind": "LinkedField",
    "name": "updatePlacementOutput",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "PlacementOutput",
        "kind": "LinkedField",
        "name": "placementOutput",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "modelID",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "widthCM",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "heightCM",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "dpi",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isEnabled",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "templateFileObjectID",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "templateFileID",
            "storageKey": null
          },
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PlacementOutputAreaItem",
            "kind": "LinkedField",
            "name": "placementOutputAreaItems",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "placementOutputAreaItemID",
                "storageKey": null
              },
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "sideID",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "areaID",
                "storageKey": null
              },
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "svg",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PlacementOutputItem",
            "kind": "LinkedField",
            "name": "placementOutputItems",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "placementOutputItemID",
                "storageKey": null
              },
              (v3/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PlacementOutputLayer",
            "kind": "LinkedField",
            "name": "placementOutputLayers",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "fileID",
                "storageKey": null
              },
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "fileObjectID",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "placementOutputLayerID",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PlacementSettings",
            "kind": "LinkedField",
            "name": "settings",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "placementOutputFileType",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "backgroundAsFillBackgroundTool",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "placementUpdatePlacementOutputMutation",
    "selections": (v4/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "placementUpdatePlacementOutputMutation",
    "selections": (v4/*: any*/)
  },
  "params": {
    "cacheID": "8bfc0e3ca853c5e0d15cfa6c6f52e1b5",
    "id": null,
    "metadata": {},
    "name": "placementUpdatePlacementOutputMutation",
    "operationKind": "mutation",
    "text": "mutation placementUpdatePlacementOutputMutation(\n  $input: PlacementOutputInputUpdateInput\n  $inputCompressed: String\n) {\n  updatePlacementOutput(input: $input, inputCompressed: $inputCompressed) {\n    placementOutput {\n      id\n      modelID\n      widthCM\n      heightCM\n      dpi\n      isEnabled\n      templateFileObjectID\n      templateFileID\n      jsonArea\n      name\n      placementOutputAreaItems {\n        placementOutputAreaItemID\n        colorID\n        sideID\n        areaID\n        json\n        svg\n      }\n      placementOutputItems {\n        placementOutputItemID\n        json\n        colorID\n      }\n      placementOutputLayers {\n        colorID\n        fileID\n        jsonArea\n        fileObjectID\n        placementOutputLayerID\n      }\n      settings {\n        placementOutputFileType\n        backgroundAsFillBackgroundTool\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "3469c8bea5f2f779bc90a21809813042";

export default node;
